<template>
    <v-card class="mx-auto mt-5" width="1000">
      <v-app-bar color="primary" dark>
        <v-toolbar-title>所属グループ一覧</v-toolbar-title>
        <v-spacer/>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="検索" single-line hide-details></v-text-field>
      </v-app-bar>
      <v-data-table
        :headers="headers"
        :items="groups"
        :search="search"
        class="mt-3"    
     >
      
      <template v-slot:[`item.groupName`]="{ item }">
        <router-link style="text-decoration: none;" :to="{name: 'GroupDetail',params: { group_id: item.groupId }}">{{item.groupName}}</router-link>
      </template>

      <template v-slot:[`item.numberOfMembers`]="{ item }">
        {{item.numberOfGroupMembers}}
      </template>

      <template v-slot:[`item.numberOfGroupJobs`]="{ item }">
        {{item.numberOfGroupJobs}}
      </template>

      <!-- 脱退ボタン -->
      <template v-slot:[`item.delete`]="{ item }">
                <span v-if="item.joined == true">参加中</span>
                <v-btn v-else-if="!isJoin(item)" color="accent" @click="joinGroupConfirm(item)">参加する</v-btn>
                <span v-else>参加中</span>

      </template>
      <!-- /脱退ボタン -->
      </v-data-table>

      <!-- グループフォームモーダルのトグルボタン -->
      <v-fab-transition v-if="isLoginUser">
      <v-btn @click="openForm()" color="accent" absolute right fixed fab x-large class="mb-5" 
        style="right:30px;bottom:50px;">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>

    <!-- グループフォームモーダル -->
    <v-dialog v-model="$store.state.groupFormModal" persistent max-width="600">
          <group-form-component ref="group_form" :form="groupForm" />
    </v-dialog>   
    </v-card>
     
</template>
<script>
import _ from 'lodash'
import {mapActions,mapGetters} from 'vuex'
import GroupFormComponent from '../components/GroupForm.vue'
  export default {
    name: 'GroupManagementComponent',
    components:{
      GroupFormComponent
    },
    created(){
      if(this.$route.params.user_id)this.fetchOtherUserGroups(this.$route.params.user_id);
    },
    data () {
      return {
        valid: true,
        // パラメーターがなければログインユーザーという意味？
        isLoginUser: !this.$route.params.user_id,
        search: '',
        groupForm: {
          title: 'グループ作成',
          subTitle: 'グループ名と募集要項を入力してグループを作成することができます',
          buttonText: '作成'
        },
        headers: [
          {
            text: 'グループ名',
            align: 'start',
            sortable: false,
            value: 'groupName',
          },
          { text: '所属人数', value: 'numberOfMembers' },
          { text: 'グループジョブ数', value: 'numberOfGroupJobs' },
          { text: 'グループリーダー', value: 'leaderOfGroup' },
          { text: '', value: 'delete' },
        ],
      }
    },
    computed:{
      groups(){
        return !this.$route.params.user_id ? this.myGroups : this.otherUsersGroups
      },
      ...mapGetters(['myGroups','otherUsersGroups','loginUserId','myGroupMembers'])
    },
    methods:{
      openForm(){
        this.toggleGroupFormModal();
        //this.$refs.group_form.resetValidation();
      },
      isJoin(group){
        const loginUserId = this.loginUserId
        //配列の中身を回してloginUserIdと比較し一致していればtrueを返す
        return group.groupMemberList.some(memberId => memberId === loginUserId)
      },
      sortArrays(arrays) {
       return _.orderBy(arrays, 'groupName', 'desc');
     },
      joinGroupConfirm(item){
        if(confirm(`本当に「${item.groupName}」に参加しますか？`)){
          item.numberOfGroupJobs = item.groupJobList.length
          item.numberOfGroupMembers = item.groupMemberList.length + 1;
          item.joined = true;
          this.joinTheGroup(item);
          this.$router.push({ name: "GroupIndex"})

        }
      },
      ...mapActions([
      'fetchMyGroups',
      'toggleGroupFormModal',
      'fetchMyGroupMembers',
      'updateMyGroup',
      'fetchOtherUserGroups',
      'joinTheGroup',
      ])
    },
  }
</script>